import { useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import type { FeedSort } from '../model/contracts'

const ALLOWED: readonly FeedSort[] = ['newest', 'oldest', 'engagement']
const DEFAULT: FeedSort = 'newest'

function parseSort(raw: string | null): FeedSort {
  if (raw && (ALLOWED as readonly string[]).includes(raw)) return raw as FeedSort
  return DEFAULT
}

export function useFeedSort(): {
  feedSort: FeedSort
  setFeedSort: (next: FeedSort) => void
} {
  const [searchParams, setSearchParams] = useSearchParams()

  const feedSort = parseSort(searchParams.get('sort'))

  const setFeedSort = useCallback(
    (next: FeedSort) => {
      setSearchParams(
        (prev) => {
          const updated = new URLSearchParams(prev)
          if (next === DEFAULT) {
            updated.delete('sort')
          } else {
            updated.set('sort', next)
          }
          return updated
        },
        { replace: true },
      )
    },
    [setSearchParams],
  )

  return { feedSort, setFeedSort }
}
